<template>
    <div class="income-by-field">
        <div>
            <div class="box chart-holder">
                <h2>{{ t("orderReports-charts-income_by_field", [label]) }}</h2>
                <pie-chart
                    :chart-data="pieCustomerChartData"
                    :height="218"
                    :value-prefix="currencySymbol"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        fieldData: {
            type: [Object, Array],
        },
        label: {
            type: String,
            default: "",
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
    computed: {
        pieCustomerChartData() {
            let labels = [];
            let dataSets = [];
            let defaultColors = [
                "#00542E",
                "#0E334E",
                "#FDB000",
                "#BFD7EA",
                "#FEDF99",
                "#A7CCC0",
                "#3366cc",
                "#dc3912",
                "#ff9900",
                "#109618",
                "#990099",
                "#0099c6",
                "#dd4477",
                "#66aa00",
                "#b82e2e",
                "#316395",
                "#994499",
                "#22aa99",
                "#aaaa11",
                "#6633cc",
                "#e67300",
                "#8b0707",
                "#651067",
                "#329262",
                "#5574a6",
                "#3b3eac",
                "#b77322",
                "#16d620",
                "#b91383",
                "#f4359e",
                "#9c5935",
                "#a9c413",
                "#2a778d",
                "#668d1c",
                "#bea413",
                "#0c5922",
                "#743411",
            ];
            let colors = [...defaultColors];
            let toUseColors = [];
            for (let v in this.fieldData) {
                let value = this.fieldData[v];
                let label = v || this.t("orderReports-tooltips-not_informed");
                labels.push(label);
                let rounded = Math.round(value.value * 100) / 100;
                dataSets.push(rounded);
                if (colors.length === 0) {
                    colors = [...defaultColors];
                }
                toUseColors.push(colors.shift());
            }
            return {
                labels: labels,
                datasets: [
                    {
                        data: dataSets,
                        backgroundColor: toUseColors,
                    },
                ],
            };
        },
    },
};
</script>
<style>
.income-by-field {
    max-height: 300px;
}
</style>
